import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";
import { extractGuidFromId } from "shared/hooks/useGetFriendlyUrlParam";

export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const designerMatch: any = matchPath(urlToMatch, {path: LinkTo.project, exact: true })
    const { id: projectId } = designerMatch?.params
    const friendlyId = extractGuidFromId(projectId)
    const projectUrl = friendlyId && `${EndpointsServer.geograffee}/api/project/Get?idProject=${friendlyId}`
    const projectResponse = friendlyId && await axios.get(projectUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const project = projectResponse?.data

    // console.log('ssrGetInitData!!!', {projectUrl, project});
    return {
        id: friendlyId,
        project,
        projectRu: project && API.toLang(project, 'ru'),
        projectEn: project && API.toLang(project, 'en'),
        definedApp,
        // notFound: projectResponse?.is404
    }
}import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";
import { extractGuidFromId } from "shared/hooks/useGetFriendlyUrlParam";

export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const designerMatch: any = matchPath(urlToMatch, {path: LinkTo.project, exact: true })
    const { id: projectId } = designerMatch?.params
    const friendlyId = extractGuidFromId(projectId)
    const projectUrl = friendlyId && `${EndpointsServer.geograffee}/api/project/Get?idProject=${friendlyId}`
    const projectResponse = friendlyId && await axios.get(projectUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const project = projectResponse?.data

    // console.log('ssrGetInitData!!!', {projectUrl, project});
    return {
        id: friendlyId,
        project,
        projectRu: project && API.toLang(project, 'ru'),
        projectEn: project && API.toLang(project, 'en'),
        definedApp,
        // notFound: projectResponse?.is404
    }
}